"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptySummary = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../shared/core");
var analytics_subjects_1 = require("../../../../analytics-subjects");
var copy_1 = require("../../../../copy");
function EmptySummary(_a) {
    var _b;
    var hasTradMeter = _a.hasTradMeter, hasNonComm = _a.hasNonComm;
    var _c = (0, core_1.useComponents)(), Card = _c.Card, Heading2 = _c.Heading2, SecondaryCTALink = _c.SecondaryCTALink, InternalLink = _c.InternalLink;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var meterReads = (0, core_1.useLinks)().meterReads;
    return (react_1.default.createElement(Card, null,
        react_1.default.createElement(Heading2, null,
            react_1.default.createElement(Copy, { copyKey: "balanceHeading" })),
        react_1.default.createElement(Copy, { copyKey: "emptyCurrentStateBalanceSubtitle" }),
        hasTradMeter ? (react_1.default.createElement(Copy, { copyKey: "emptyCurrentStateBalanceBody" })) : hasNonComm ? (react_1.default.createElement(Copy, { copyKey: "emptyStateSmartNonCommsBalanceBody" })) : (react_1.default.createElement(Copy, { copyKey: "emptyStateSmartMeterBalanceBody" })),
        (hasTradMeter || hasNonComm) && (react_1.default.createElement(ui_tools_1.AnalyticsClick, { name: analytics_subjects_1.BILLING_DETAILS_PAGE_SUBMIT_METER_READ, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
            react_1.default.createElement(SecondaryCTALink, { as: InternalLink, href: meterReads() },
                react_1.default.createElement(Copy, { copyKey: "emptyCurrentStateBalanceSubmitMeterReading" }))))));
}
exports.EmptySummary = EmptySummary;
